import { useMemo } from 'react';

import {
  AgentDto,
  ToolDto,
  useToolListControllerAgentTollListQuery,
} from '@shared/services/apiService/apiService';
import { ToolTypeEnum } from '@shared/constants/campaign.constants';

export const useAgentAdvancedSettingsTools = ({
  open,
  agent,
  campaignTools,
}: {
  open: boolean;
  agent: AgentDto;
  campaignTools: ToolDto[];
}) => {
  const {
    data: fetchedAgentTools,
    isLoading: isLoadingAgentTools,
    refetch: refetchAgentTools,
  } = useToolListControllerAgentTollListQuery({ id: agent.id || '' }, { skip: !open || !agent.id });

  const agentNonMcpTools = useMemo(() => {
    const tools = fetchedAgentTools ?? agent.tools ?? [];
    return tools.filter((tool) => tool.type !== ToolTypeEnum.Mcp);
  }, [fetchedAgentTools, agent.tools]);

  const allAgentTools = useMemo(() => {
    if (fetchedAgentTools) return fetchedAgentTools;
    return campaignTools;
  }, [fetchedAgentTools, campaignTools]);

  return {
    agentNonMcpTools,
    allAgentTools,
    isLoadingAgentTools,
    refetchAgentTools,
  };
};
